import * as React from 'react';
import {FunctionComponent} from 'react';
import {EventType} from '../../../../../models/PartEvent';
import {Icon} from '../../components/Icon';

interface OwnProps {
    onSelect: (eventType: EventType) => void;
    onCancel: () => void;
}

export const EventTypeStepComponent: FunctionComponent<OwnProps> = ({onSelect, onCancel}) => {
    function getButton(eventType: EventType): JSX.Element {
        switch (eventType) {
            case EventType.DataField0:
            case EventType.DataField1:
            case EventType.DataField2:
            case EventType.DataField3:
                return (
                    <button className="add-event-wizard__select-type-btn" onClick={() => onSelect(eventType)}>
                        <Icon eventType={eventType} />
                        <span>Set data field</span>
                    </button>
                );
            case EventType.Target:
                return (
                    <button className="add-event-wizard__select-type-btn" onClick={() => onSelect(EventType.Target)}>
                        <Icon eventType={EventType.Target} />
                        <span>Set target</span>
                    </button>
                );
            case EventType.Instruction:
                return (
                    <button
                        className="add-event-wizard__select-type-btn"
                        onClick={() => onSelect(EventType.Instruction)}
                    >
                        <Icon eventType={EventType.Instruction} />
                        <span>Add instruction</span>
                    </button>
                );
            case EventType.MainVisualisation:
                return (
                    <button
                        className="add-event-wizard__select-type-btn"
                        onClick={() => onSelect(EventType.MainVisualisation)}
                    >
                        <Icon eventType={EventType.MainVisualisation} />
                        <span>Set visualisation</span>
                    </button>
                );
        }
    }

    return (
        <>
            <div className="modal-header">
                <h2>Choose event type</h2>
            </div>
            <div className="modal-body">
                <div className="add-event-wizard">
                    <div className="add-event-wizard__btn-container">
                        {[
                            EventType.Target,
                            EventType.DataField0,
                            EventType.Instruction,
                            EventType.MainVisualisation,
                        ].map((eventType) => (
                            <React.Fragment key={eventType}>{getButton(eventType)}</React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    );
};
